import { AbstractControl } from '@angular/forms';
import { GenericAccountValidator } from './generic-account-validator';

export class MexicoBankAccountValidator extends GenericAccountValidator {
    protected static errors: any = {
        'es-AR': {
            bad_email: 'CLABE incorrecto, debe ser por ejemplo: 032180000118359719'
        },
        'en-US': {
            bad_email: 'Incorrect CLABE, here`s an example: 032180000118359719'
        }
    };
    protected static label: any = {
        'es-AR': 'CLABE para',
        'en-US': 'CLABE for'
    };
    protected static placeholder: any = {
        'es-AR': 'Por ejemplo: 032180000118359719',
        'en-US': 'For example: 032180000118359719'
    };
    public getLabelToAccountType(): string {
        return MexicoBankAccountValidator.label[MexicoBankAccountValidator.lang] ?? MexicoBankAccountValidator.label['es-AR'];
    }

    public getPlaceholderToAccountType(): string {
        return MexicoBankAccountValidator.placeholder[MexicoBankAccountValidator.lang] ?? MexicoBankAccountValidator.placeholder['es-AR'];
    }

    public accountValidate(control: AbstractControl): { [key: string]: any } | null {
        let error: any = MexicoBankAccountValidator.errors[MexicoBankAccountValidator.lang] ?? MexicoBankAccountValidator.errors['es-AR'];
        if (/^[0-9]{18}$/.test(control.value) && MexicoBankAccountValidator.computeControlDigit(control.value)) {
            return null;
        }

        return { forbiddenName: error.bad_email };
    }

    public static computeControlDigit(clabe: string): boolean {
        const WEIGHT_FACTORS: Array<number> = [3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7];
        const MODULE_TEN: number = 10;
        let clabeChars: Array<string> = clabe.split('');
        let accumulator: number = 0;

        WEIGHT_FACTORS.forEach((key, index): void => {
            accumulator = accumulator + ((Number(clabeChars[index]) * key) % MODULE_TEN);
        });

        let controlDigit: number = MODULE_TEN - (accumulator % MODULE_TEN);
        controlDigit = controlDigit === 10 ? 0 : controlDigit;

        return clabeChars[clabeChars.length - 1] === controlDigit.toString();
    }
}
